import CheckIcon from '@mui/icons-material/Check';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';

import { Context } from '../../service/Context';
import { estiloBotonTablaJugador, IconButtonApp } from '../custom/CustomComponents';

/**
 * Botón para confirmar la edad de un jugador.
 */
const BotonEdadCheck = ({ idJugador, checkInicial, enLista, onChange }) => {
  const { modificarEdadCheckJugador } = useContext(Context);
  const [edadCheck, setEdadCheck] = useState(checkInicial);

  useEffect(() => {
    setEdadCheck(checkInicial);
  }, [checkInicial]);

  // Manejo del evento de click en el boton
  function clickEdadCheck(e) {
    if (e) {
      e.stopPropagation();
    }
    const nuevoCheck = !edadCheck;
    modificarEdadCheckJugador(idJugador, nuevoCheck);
    setEdadCheck(nuevoCheck);
    if (onChange) {
      onChange(nuevoCheck);
    }
  }

  if (!idJugador) {
    return null;
  }

  return (
    <Tooltip title={edadCheck ? 'Año verificado' : 'Año sin verificar'} arrow>
      <IconButtonApp
        onClick={clickEdadCheck}
        enLista={enLista}
        border
        style={estiloBotonTablaJugador(edadCheck)}
        sx={{ width: 22, height: 22, p: 0 }}
      >
        {edadCheck ? <CheckIcon sx={{ fontSize: '0.9rem' }} /> : <QuestionMarkIcon sx={{ fontSize: '0.85rem' }} />}
      </IconButtonApp>
    </Tooltip>
  );
};

BotonEdadCheck.propTypes = {
  idJugador: PropTypes.number,
  checkInicial: PropTypes.bool,
  enLista: PropTypes.bool,
  onChange: PropTypes.func,
};

export default BotonEdadCheck;
